import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SnackbarComponent } from './snackbar/snackbar.component';
import { TranslateModule } from '@ngx-translate/core';
import { SnackbarData } from './utils/snackbar-config';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [SnackbarComponent],
  imports: [CommonModule, TranslateModule, RouterModule],
  providers: [SnackbarData],
  exports: [SnackbarComponent],
})
export class SnackbarModule {}
